export default {
  title: "Authorization {id}",
  createdAt: "Created at",
  beneficiary: "Beneficiary",
  memberCode: "Member Code",
  coverage: "Coverage",
  sponsor: "Sponsor",
  settlementId: "Settlement ID",
  doctor: "Doctor",
  specialty: "Specialty",
  licenseNumber: "License number",
  branch: "Branch",
  productName: "Outpatient care type",
  additionalDocuments: "Additional documents",
  supportDocuments: "General documents",
  requiereDocuments: "Required documents",
  optionalDocuments: "Optional documents",
  claim: "Claim",
  authorization: "Authorizacion",
  documentation: {
    label: "Documentation",
    incomplete: "Incomplete (Docs {uploaded}/{total})",
    complete: "Complete",
    require: "(Required)"
  },
  attachDialog: {
    attachFiles: "Attach files",
    additionalFiles: "Additional documents (optional)",
    fileFormats: "Files in format PDF, PNG, JPEG, XML up to 10Mb",
    addFileDescription: "Attach other documents that you consider necessary and relevant for the authorization"
  },
  buttons: {
    back: "Back",
    attachDocument: "Attach",
    addDocument: "Add",
    replace: 'Replace'
  },
  emptyState: {
    documents: "Attach documents not found",
    noResults: "Information not found",
    noResultsDescription: "The desired outpatient care claim was not found."
  },
  preview: {
    title: "Preview",
    label: "This file has no preview.",
    actions: {
      cancel: "Cancel",
      download: "Download",
      delete: "Delete"
    }
  },
  diagnoses: {
    title: "Diagnoses",
    headers: {
      diagnosisCode: "CIE - 10 Code",
      diagnosisName: "Name",
      status: "Status"
    },
    status: {
      approved: "Approved",
      rejected: "Rejected",
      manualApprovalRequired: "Manual approval required"
    }
  },
  treatments: {
    title: 'Prescribed treatments',
    headers: {
      name: 'Drug',
      treatment: 'Treatment'
    }
  },
  products: {
    title: "Claims information",
    headers: {
      productNames: {
        drugs: "Medicines",
        diagnosticTests: "Laboratories",
        medicalProcedures: "Medical procedure"
      },
      productName: "Product",
      price: "Unit price",
      refill: "Refill",
      refillValues: "{refillNumber} of {numberOfRefills}",
      quantity: "Quantity",
      status: "Status",
      claim: "Claim"
    },
    status: {
      approved: "Approved",
      rejected: "Rejected",
      claimed: "Claimed",
      manualApprovalRequired: "Manual approval required",
      partiallyClaimed: "Partially claimed"
    }
  },
  void: "Void authorization",
  detailV2: {
    authorization: "Authorization",
    createdAt: "Created at",
    newAssessment: "New assessment",
    patientDischarge: "Patient discharge",
    addInvoice: "Send invoice",
    files: "Insurance company formats",
    tabs: {
      information: "Information",
      documentation: "Documentation",
      observations: "Observations",
    },
    beneficiary: {
      coverage: "Coverage",
      insured: "Insured",
      identification: "Identification",
      sponsor: "Sponsor",
      label: 'Beneficiary',
      inactive: "is inactive",
      and: "and",
      noBenefitAvailable: "does not meet the minimum insured amount",
      maximumBenefitAvailable: 'Available amount {0}'
    },
    doctor: {
      physician: "Physician",
      specialty: "Specialty",
      license: "License",
    },
    observations: {
      empty: "No observations",
      today: "Today {date}",
      addComment: "Enter your comment",
    },
    addInvoiceDialog: {
      title: "Patient discharge",
      subtitle: "Attach the pre-account document to discharge the patient",
      sectionTitle: "Document"
    },
    documentation: {
      search: 'Search',
      type: 'Support type',
      fileName: 'File name',
      required: 'Required',
      actions: 'Actions',
      addDocument: 'Add document',
      yes: 'Yes',
      no: 'No',
      downloadSuccess: 'Download successful',
      replaceSuccess: 'Replacement successful',
      deleteSuccess: 'Deletion successful',
      deleteFileMessage: "Are you sure you want to delete the selected file?",
      deleteFileConfirmation: "This action cannot be undone.",
      createdAt: "Upload date"
    },
    uploadFiles: {
      title: "Add documents",
      selectDocumentType: "Select document type",
      addDocumentsButton: "Add documents",
      uploadButton: "Done and close",
      cancelMessage: "Are you sure you want to cancel the selection of documents?",
      lostInformationMessage: "The information entered will be lost",
      maxFilesLimit: "It is only possible to select up to {maxFiles} files.",
      maxFileLimit: "It is only possible to select up to {maxFiles} file.",
      maxFilesLimitByType: "It is only possible to select up to {maxFiles} files by type.",
      maxSizeError: "The following file(s) exceed the maximum allowed size ({maxSize} MB): {files}",
      numberHeader: "No.",
      fileTypeHeader: "Document type",
      fileNameHeader: "File name",
      actionsHeader: "Actions"
    }
  }
}
